import React, { useEffect, useContext } from 'react'
import CopyLinkSVG from 'images/copy-link.svg'
import copy from 'copy-to-clipboard'
import { modalContext } from 'global/context/sub-contexts/modalContext'

import TextField from '@mui/material/TextField'
import './ForgotPasswordModal.scss'
import './CopyLinkModal.scss'

const CopyLinkModal = ({ closeModal }) => {
  const modal_context = useContext(modalContext)
  const { modalContent } = modal_context || {}
  const theUrl = modalContent.shareUrl
    ? modalContent.shareUrl
    : window !== `undefined` && window.location.href

  useEffect(() => {
    if (window !== `undefined`) {
      let urlInput = document.querySelector(
        '.modal-copy-link .input-container input',
      )
      urlInput.select()
      copy(urlInput.value)
    }
  }, [])

  return (
    <div className={`modal-forgot modal-copy-link new-form-fields `}>
      <button
        className="modal-close gray-close-button"
        onClick={closeModal}
        aria-label="Next"
      ></button>
      <img className="header-image" src={CopyLinkSVG} alt="" />
      <h1>Link Copied </h1>
      <p>Shareable link has been copied to your clipboard.</p>
      <div className="input-container">
        <TextField id="outlined-basic" variant="outlined" value={theUrl} />
      </div>
    </div>
  )
}

export default CopyLinkModal
